import { useAiFieldCellLoadingState } from '../use-ai-field-cell-loading-state.ts';

import type { AiFieldCellRequestTarget } from './ai-field-cell-request-coordinator.ts';

export type UseIsAiFieldCellProcessingOptions = Omit<
  AiFieldCellRequestTarget,
  'isTargetValueEmpty'
> & {
  isTargetValueEmpty?: boolean;
};

export const useIsAiFieldCellProcessing = ({
  contentId,
  aiFieldType,
  fieldId,
  entryId,
  isTargetValueEmpty = false
}: UseIsAiFieldCellProcessingOptions): boolean => {
  const loadingState = useAiFieldCellLoadingState({
    contentId,
    aiFieldType,
    fieldId,
    entryId,
    isTargetValueEmpty
  });

  return loadingState !== null;
};
